import { isHandledErrorKey } from 'src/dataLayer/remoteData/babbelAPI/shared/handledErrorKeys'
import {
  reportCrossOriginScriptError,
  reportUncaughtException,
  reportUnhandledRejection,
} from 'src/dataLayer/remoteData/rollbar'

const isMaskedCrossOriginError = (message, error) =>
  !error && typeof message === 'string' && message.startsWith('Script error')

const isBenignBrowserNoise = (message) =>
  typeof message === 'string' && message.includes('ResizeObserver loop')

const isBrowserExtensionError = (url) => /^(?:chrome|moz|safari)-extension:/.test(url || '')

// eslint-disable-next-line unicorn/prefer-add-event-listener -- we need to use onerror for legacy compatibility
globalThis.onerror = (message, url, lineNumber, columnNumber, error) => {
  if (isBenignBrowserNoise(message) || isBrowserExtensionError(url)) {
    return false
  }
  if (isMaskedCrossOriginError(message, error)) {
    reportCrossOriginScriptError()
  } else {
    reportUncaughtException(message, url, lineNumber, columnNumber, error)
  }
  // returning false keeps the default browser error logging in place
  return false
}

globalThis.onunhandledrejection = (event) => {
  if (!isHandledErrorKey(event.reason)) {
    reportUnhandledRejection(event.reason)
  }
}
